/**
 * Hero Menu mobile toggle functionality
 */
const heroMenu = {
    init() {
        this.setupMobileToggle();
    },

    setupMobileToggle() {
        const toggleButton = document.querySelector('.hero-menu__toggle');
        const nav = document.querySelector('.hero-menu__nav');

        if (!toggleButton || !nav) {
            return;
        }

        toggleButton.addEventListener('click', () => {
            toggleButton.classList.toggle('active');
            nav.classList.toggle('active');
        });

        // Close menu when clicking outside
        document.addEventListener('click', (event) => {
            const isClickInsideMenu = event.target.closest('.hero-menu__nav');
            const isClickOnToggle = event.target.closest('.hero-menu__toggle');

            if (!isClickInsideMenu && !isClickOnToggle && nav.classList.contains('active')) {
                nav.classList.remove('active');
                toggleButton.classList.remove('active');
            }
        });

        // Close menu on window resize to desktop
        window.addEventListener('resize', () => {
            if (window.innerWidth >= 992) {
                nav.classList.remove('active');
                toggleButton.classList.remove('active');
            }
        });
    }
};

export default heroMenu;

